import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PendoSignals from "./pages/PendoSignals";
import PendoFrameworks from "./pages/PendoFrameworks";
import RefersionAmazon from "./pages/RefersionAmazon";
import RefersionMarketplace from "./pages/RefersionMarketplace";
import UNOS from "./pages/UNOS";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pendo-signals" element={<PendoSignals />} />
        <Route path="/pendo-frameworks" element={<PendoFrameworks />} />
        <Route path="/refersion-amazon" element={<RefersionAmazon />} />
        <Route path="/refersion-marketplace" element={<RefersionMarketplace />} />
        <Route path="/unos" element={<UNOS />} />
      </Routes>
    </BrowserRouter>
  );
}
